import React, { useContext, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import { numberFormat } from '../../../helpers/helperFunctions';
import useClientCallOutDashboard from '../context/useClientCallOutDashboard';

export default function ClientCallOutMoeTable() {
  const { cncDashboardMoe } = useContext(useClientCallOutDashboard);
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'description',
      headerName: 'Mode of Engagement',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'no_of_engagement',
      headerName: 'No of Engagement',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => numberFormat(row.no_of_engagement),
    },
    {
      field: 'collection',
      headerName: 'Collection',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => numberFormat(row.collection),
    },
    {
      field: 'percent_moe',
      headerName: '% of MOE',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => `${numberFormat(row.percent_moe)}%`,
    },
    {
      field: 'percent_collection',
      headerName: '% of Collection',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => `${numberFormat(row.percent_collection)}%`,
    },
  ];

  const pinnedRows = {
    bottom: cncDashboardMoe?.table?.length ? [cncDashboardMoe?.table[0]] : [],
  };

  return (
    <Box
      className='table-container'
      sx={{
        height: `400px`,
        '& .super-app-theme--header': {
          backgroundColor: '#6B8D3E',
          color: '#fff',
        },
        '& .cell-green': {
          backgroundColor: '#ACE1AF',
          color: '#000',
          fontWeight: '600',
        },
        '& .cell-yellow': {
          backgroundColor: '#f0ad4e',
          color: '#000',
          fontWeight: '600',
        },
        '& .cell-red': {
          backgroundColor: '#FFADB0',
          color: '#000',
          fontWeight: '600',
        },
        '& .cell-super-green': {
          backgroundColor: '#5cb85c',
          color: '#000',
          fontWeight: '600',
        },
        '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#6B8D3E' },
      }}
      mt={1}
    >
      <DataGridPro
        loading={cncDashboardMoe?.loading}
        rows={cncDashboardMoe?.table}
        columns={columns}
        sortModel={sortModel}
        experimentalFeatures={{ rowPinning: true }}
        initialState={{
          ...cncDashboardMoe?.table.initialState,
          pagination: {
            pageSize: 50,
          },
        }}
        pinnedRows={pinnedRows}
        rowsPerPageOptions={[10, 25, 50]}
        pagination
        onSortModelChange={(model) => setSortModel(model)}
      />
    </Box>
  );
}
